import React, { useState, useEffect } from "react";
import { Steps, Typography, Button } from "antd";
import FormWrapper from "./FormWrapper";
import StepsWizardWrapper from "./StepsWizard.style";
import { CloseOutlined } from "@ant-design/icons";
import AnimationWrapper from "../animations/AnimationWrapper";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const { Title } = Typography;
const { Step } = Steps;

const StepsWizard = (props) => {
  const {
    onFinish,
    onFinishFailed,
    onValuesChange,
    onDecline,
    saveLoading,
    steps,
    values,
    onCancel,
    createText,
    nextDisabled,
    setNext,
    changeValues,
    formLayout,
    changeCurrentSlide,
  } = props;
  let { branchId } = useParams();

  const [current, setCurrent] = useState(0);
  const [form, setForm] = useState(null);
  const [isSlideFieldsValidated, setIsSlideFieldsValidated] = useState(false);
  const [isRequiredTouched, setIsRequiredTouched] = useState(false);
  const [errorFieldsNames, setErrorFieldsNames] = useState([]);
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);

  useEffect(() => {
    setNext(!(isSlideFieldsValidated && isRequiredTouched));
    if (changeCurrentSlide) {
      changeCurrentSlide(current);
    }
  }, [current, isSlideFieldsValidated, isRequiredTouched]);

  useEffect(() => {
    async function validate(arr) {
      const invalidatedFields = await getInvalidatedFields(arr);
      const isValidated = invalidatedFields.length === 0;
      setIsSlideFieldsValidated(isValidated);
      setErrorFieldsNames(invalidatedFields);
    }
    validate(steps[current]["validation"]);
    const isTouched = checkIfTouched(steps[current]["required"]);
    setIsRequiredTouched(isTouched);
  }, [branchId, values, current, steps]);

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };
  const getInvalidatedFields = async (arr) => {
    if (form) {
      let errors = [];
      let fieldsNames = [];
      await sleep(100);
      const fieldsErrors = form.getFieldsError(arr);
      fieldsErrors.forEach((item, i) => {
        if (item.errors.length > 0) {
          fieldsNames.push(item.name);
          item.errors.forEach((er, i) => {
            errors.push(er);
          });
        }
      });
      return fieldsNames;
    } else {
      return false;
    }
  };

  const checkIfTouched = (arr) => {
    let check = true;
    arr.forEach((item, i) => {
      if (form) {
        const value = form.getFieldValue(item);
        if (value === undefined || value === null || value === "") {
          check = false;
        }
        if (Array.isArray(value) && value.length === 0) {
          check = false;
        }
      }
    });
    return check;
  };

  const setInitialForm = (f) => {
    setForm(f);
  };

  const onChange = (c) => {
    setCurrent(c);
  };

  const onContinue = () => {
    setCurrent(current + 1);
  };

  const onBack = () => {
    setCurrent(current - 1);

    if (form) {
      const resetfields = {};
      errorFieldsNames.forEach((item, i) => {
        resetfields[item] = null;
      });
      changeValues({ ...values, ...resetfields });
      form.setFieldsValue({ ...values, ...resetfields });
    }
  };
  const layout = formLayout
    ? formLayout
    : {
        labelCol: { span: 9 },
        wrapperCol: { span: 15 },
      };
  const items = steps.map((step, i) => ({
    key: i,
    title: step.title,
    description: step.description,
    disabled: (i > current && nextDisabled) || i - current > 1,
  }));
  return (
    <StepsWizardWrapper direction={currentAppLocale.direction}>
      <div className="steps">
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={onCancel}
        />

        <Steps
          size="small"
          current={current}
          onChange={onChange}
          items={items}
        />
      </div>
      <div className="inner">
        <div className="header">
          <Title level={2}>{steps[current].headline}</Title>
          <Title level={4}>{steps[current].subtitle}</Title>
        </div>
        <div className="form">
          <FormWrapper
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onValuesChange={(changedValues, allValues) =>
              onValuesChange(changedValues, allValues, form)
            }
            setInitialForm={setInitialForm}
            onDecline={onDecline}
            saveLoading={saveLoading}
            current={current}
            steps={steps}
            onContinue={onContinue}
            onBack={onBack}
            createText={createText}
            nextDisabled={nextDisabled}
            direction={currentAppLocale.direction}
            layout={layout}
          >
            {steps.map((step, i) =>
              i === current ? (
                <AnimationWrapper key={i} duration={0.6}>
                  {step.comp}
                </AnimationWrapper>
              ) : (
                <div key={i} style={{ display: "none" }}>
                  {step.comp}
                </div>
              )
            )}
          </FormWrapper>
        </div>
      </div>
    </StepsWizardWrapper>
  );
};

export default StepsWizard;
